import React from 'react';
import bars from './svgs/bars';
import Audio from './svgs/audio';
import BallTriangle from './svgs/ball-triangle';
import Circles from './svgs/circles';
import Grid from './svgs/grid';
import Hearts from './svgs/hearts';
import Oval from './svgs/oval';
import Puff from './svgs/puff';
import Rings from './svgs/rings';
import SpnningCircles from './svgs/spinning-circles';
import TailSpin from './svgs/tail-spin';
import ThreeDots from './svgs/three-dots';


const loaders = {
  'bars': bars,
  'audio': Audio,
  'ball-triangle': BallTriangle,
  'circles': Circles,
  'grid': Grid,
  'hearts': Hearts,
  'oval': Oval,
  'puff': Puff,
  'rings': Rings,
  'spinning-circles': SpnningCircles,
  'tail-spin': TailSpin,
  'three-dots': ThreeDots,
};

export default ({ type = 'oval', className = 'loader-container', width, height }) => {
  const LoaderComponent = loaders[type];
  return (
    <div className={className}>
      <LoaderComponent width={width} height={height}/>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/Loaders/Loaders.js